import {createContext} from 'react';

const AutenticacaoContext = createContext<() => void>(undefined!);

export default AutenticacaoContext;